module.exports = __webpack_public_path__ + "static/orange_icon-6ab5721130eeec10d571764d83ede3cd.png";